export const userEndpoint = {
  fetchAll: "https://jsonplaceholder.typicode.com/users",
};

export const commentsEndpoint = {
  fetchAll: "https://jsonplaceholder.typicode.com/comments",
};

/*
async function getUserData (userId){
"www.nassajt.com/api/user/{:userId}".replace('{:userId}', userId)

}

GET - fetching data
POST - sending data
PUT - Update data
DELETE - delete data / user
*/
